import { Navigate, Route, Routes } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import {
  MemberProfile,
  MemberPermissions,
  AddMembers,
  MemberInboxes,
} from 'pages/settings/pages/members/pages'
import { MembersAccessLayout } from 'pages/settings/pages/members/layout/MembersAccessLayout'
import { MembersLayout } from 'pages/settings/pages/members/layout/MembersLayout'
import { MemberLayout } from 'pages/settings/pages/members/layout/MemberLayout'
import { MembersRoutes } from 'pages/settings/pages/members/route/type'
import { ActiveMembersTab } from 'pages/settings/pages/members/pages/membersView/ui/ActiveMembersTab/ActiveMembersTab'
import { PendingMembersTab } from 'pages/settings/pages/members/pages/membersView/ui/PendingMembersTab/PendingMembersTab'
import {
  InboxAccessTab,
  PermissionsUpdateTab,
  SalesmsgAccessTab,
} from 'pages/settings/pages/members/pages/membersView/ui/RequestsMembersTab/ui'
import { RequestsLayout } from 'pages/settings/pages/members/layout/RequestsLayout'
import { MembersListLayout } from 'pages/settings/pages/members/layout/MembersListLayout'

export const MembersRouter = observer(() => {
  return (
    <Routes>
      <Route element={<MembersAccessLayout />}>
        <Route element={<MembersLayout />}>
          <Route element={<MembersListLayout />}>
            <Route index element={<Navigate to={MembersRoutes.active} replace />} />
            <Route path={MembersRoutes.active} element={<ActiveMembersTab />} />
            <Route path={MembersRoutes.pending} element={<PendingMembersTab />} />
            <Route path={`${MembersRoutes.requests}/*`} element={<RequestsLayout />}>
              <Route index element={<Navigate to={MembersRoutes.salesmsgAccess} replace />} />
              <Route path={MembersRoutes.salesmsgAccess} element={<SalesmsgAccessTab />} />
              <Route path={MembersRoutes.inboxAccess} element={<InboxAccessTab />} />
              <Route path={MembersRoutes.permissionsUpdate} element={<PermissionsUpdateTab />} />
            </Route>
          </Route>
          <Route path={MembersRoutes.add} element={<AddMembers />} />
          <Route path={MembersRoutes.id} element={<MemberLayout />}>
            <Route path={MembersRoutes.profile} element={<MemberProfile />} />
            <Route path={MembersRoutes.permissions} element={<MemberPermissions />} />
            <Route path={MembersRoutes.inboxes} element={<MemberInboxes />} />
          </Route>
          <Route path={'*'} element={<Navigate to={MembersRoutes.root} />} />
        </Route>
      </Route>
    </Routes>
  )
})
